/**
 * Product create/update body keys accepted by backend ProductSchemas.
 * Server-owned and mapped read-model fields are excluded on purpose.
 * Admin uses the same body keys as the shared product write schema;
 * actor/signing/archive/version protections stay server-owned.
 */
export const PRODUCT_WRITE_KEYS = [
  'isBuyNowDisabled',
  'hasAdminEdited',
  'sellerPhotoUrl',
  'accountId',
  'accountName',
  'contactId',
  'contactName',
  'listingType',
  'status',
  'title',
  'description',
  'equipmentVinNumber',
  'serialNumber',
  'isTheEquipmentAtADifferentAddress',
  'equipmentHours',
  'equipmentMileage',
  'purchaseMethod',
  'productManufacturer',
  'model',
  'year',
  'lienInfo',
  'acceptOffers',
  'buyNowPriceMap',
  'initialReservePriceMap',
  'openingPriceMap',
  'finalSalePriceMap',
  'equipmentId',
  'subcategoryId',
  'auctionInfo',
  'newOrUsedEquipment',
  'websiteLink',
  'zohoEquipmentType',
  'commissionPercentage',
  'buyersPremium',
  'expectedRevenue',
  'isCommissionSetManually',
  'isBuyersPremiumSetManually',
  'isThisATitledPieceOfEquipment',
  'willYouProvideTheElectricalDisconnectIfRequired',
  'willYouLoadTheEquipmentOnToTheBuyersTrucks',
  'doesThisRequireDismantling',
  'contractInfo',
  'isFeaturedListing',
  'salesStartDate',
  'salesEndDate',
  'isSynced',
  'isMigrated',
  'isAssetSync',
  'productDetails',
  'views',
  'endedAt',
  'requestedChanges',
  'zohoId',
  'productCode',
  'isReportGenerated'
] as const

export function pickWritableProductFields<T extends Record<string, any>>(
  payload: T
): Partial<T> {
  const next: Record<string, T[keyof T]> = {}

  for (const key of PRODUCT_WRITE_KEYS) {
    if (!Object.prototype.hasOwnProperty.call(payload, key)) continue
    const value = payload[key]
    if (value === undefined) continue
    next[key] = value
  }

  return next as Partial<T>
}
